const Policy = {
  HOL: "policy",
  MOL: "plan"
};

export default Policy;
